var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarouselArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1 1.428l7.046 6.547-6.89 6.646 1.5 1.378L9 7.925.45-.001-1 1.428z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDkgMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNLTEgMS40Mjc1OUw2LjA0NjI4IDcuOTc0OTlMLTAuODQzNzUgMTQuNjIwN0wwLjY1NjI2NSAxNS45OTlMOC45OTg3OCA3LjkyNDczTDAuNDUwMDQzIC0wLjAwMDk4MDM2MkwtMSAxLjQyNzU5WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
export { SvgCarouselArrow as ReactComponent };